import '@quasar/extras/mdi-v5/mdi-v5.css';
import '@quasar/extras/roboto-font/roboto-font.css';
import 'quasar/dist/quasar.ie.polyfills';

import './styles/quasar.scss';
import Vue from 'vue';
import {
  ClosePopup,
  Dialog,
  LocalStorage,
  Notify,
  QAvatar,
  QBadge,
  QBar,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QBtn,
  QBtnDropdown,
  QBtnGroup,
  QCard,
  QCardActions,
  QCardSection,
  QCheckbox,
  QChip,
  QCircularProgress,
  QDate,
  QDialog,
  QDrawer,
  QEditor,
  QExpansionItem,
  QField,
  QFooter,
  QForm,
  QHeader,
  QIcon,
  QImg,
  QInnerLoading,
  QInput,
  QItem,
  QItemLabel,
  QItemSection,
  QLayout,
  QList,
  QMarkupTable,
  QMenu,
  QOptionGroup,
  QPage,
  QPageContainer,
  QPopupProxy,
  QRadio,
  QRating,
  QSelect,
  QSeparator,
  QSpace,
  QSpinnerGears,
  QSplitter,
  QTab,
  QTable,
  QTabPanel,
  QTabPanels,
  QTabs,
  QTd,
  QTh,
  QToggle,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  QTr,
  Quasar,
  QVirtualScroll,
  Scroll,
  ScrollFire,
  SessionStorage,
  QColor,
  QFile,
} from 'quasar';

import iconSet from 'quasar/icon-set/mdi-v5';

Vue.use(Quasar, {
  config: {
    notify: {
      position: 'top-right',
      timeout: 2500,
      textColor: 'white',
      actions: [{ icon: 'mdi-close', color: 'white' }],
    },
  },
  directives: {
    ClosePopup,
    Scroll,
    ScrollFire,
  },
  plugins: {
    LocalStorage,
    SessionStorage,
    Notify,
    Dialog,
  },
  iconSet: iconSet,
});

Vue.component('QEditor', QEditor);
Vue.component('QRating', QRating);
Vue.component('QTable', QTable);
Vue.component('QList', QList);
Vue.component('QMenu', QMenu);
Vue.component('QLayout', QLayout);
Vue.component('QHeader', QHeader);
Vue.component('QDrawer', QDrawer);
Vue.component('QFooter', QFooter);
Vue.component('QPageContainer', QPageContainer);
Vue.component('QPage', QPage);
Vue.component('QToolbar', QToolbar);
Vue.component('QToolbarTitle', QToolbarTitle);
Vue.component('QBtn', QBtn);
Vue.component('QIcon', QIcon);
Vue.component('QItem', QItem);
Vue.component('QItemSection', QItemSection);
Vue.component('QItemLabel', QItemLabel);
Vue.component('QCard', QCard);
Vue.component('QCardActions', QCardActions);
Vue.component('QCardSection', QCardSection);
Vue.component('QInput', QInput);
Vue.component('QCheckbox', QCheckbox);
Vue.component('QForm', QForm);
Vue.component('QTh', QTh);
Vue.component('QTr', QTr);
Vue.component('QTd', QTd);
Vue.component('QBreadcrumbs', QBreadcrumbs);
Vue.component('QBreadcrumbsEl', QBreadcrumbsEl);
Vue.component('QBtnDropdown', QBtnDropdown);
Vue.component('QBtnGroup', QBtnGroup);
Vue.component('QAvatar', QAvatar);
Vue.component('QToggle', QToggle);
Vue.component('QSeparator', QSeparator);
Vue.component('QSelect', QSelect);
Vue.component('QImg', QImg);
Vue.component('QDialog', QDialog);
Vue.component('QTooltip', QTooltip);
Vue.component('QSpace', QSpace);
Vue.component('QBar', QBar);
Vue.component('QInnerLoading', QInnerLoading);
Vue.component('QSpinnerGears', QSpinnerGears);
Vue.component('QExpansionItem', QExpansionItem);
Vue.component('QBadge', QBadge);
Vue.component('QChip', QChip);
Vue.component('QTabs', QTabs);
Vue.component('QTab', QTab);
Vue.component('QRadio', QRadio);
Vue.component('QOptionGroup', QOptionGroup);
Vue.component('QTabPanels', QTabPanels);
Vue.component('QTabPanel', QTabPanel);
Vue.component('QDate', QDate);
Vue.component('QVirtualScroll', QVirtualScroll);
Vue.component('QPopupProxy', QPopupProxy);
Vue.component('QCircularProgress', QCircularProgress);
Vue.component('QField', QField);
Vue.component('QMarkupTable', QMarkupTable);
Vue.component('QColor', QColor);
Vue.component('QSplitter', QSplitter);
Vue.component('QFile', QFile);
